import React from 'react'

const Manual_admin_plano_de_mesa = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Plano de Mesa
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        La guía proporciona instrucciones paso a paso para crear y personalizar la distribución de mesas de
        manera sencilla. Permite agregar, copiar y organizar mesas según las necesidades del usuario.
        </p>
        <iframe
        src="https://scribehow.com/embed/Admin__Plano_de_Mesa__Uv9k7m8_TwKHqEeFg1yBnA?as=scrollable"
        className="scribe-iframe-general-20"
        width="100%"
        height="6100"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_admin_plano_de_mesa